import React from 'react';
import '../../styles/c_HomeBoutique.css';
import { useHomeData } from '../../hooks/useHomeData';

function HomeBoutique() {
    const { data } = useHomeData();
    const boutiqueData = data?.boutique;

    if (!boutiqueData?.title) {
        return <div className="loadingFiller"></div>;
    }

    return (
        <>
            <div id='homeBoutiqueWrapper'>
                <div className="homeBoutiqueImage">
                    <img src={boutiqueData.image.path} alt={boutiqueData.image.alt} loading='lazy' decoding='async' />
                </div>
                <div className="homeBoutiqueContent">
                    <h2 className='homeBoutiqueTitle'><a href={boutiqueData.button.href} target="_blank" rel="noreferrer">{boutiqueData.title}</a></h2>
                    <p className='homeBoutiqueSubtitle'>{boutiqueData.subtitle}</p>
                    <p className='homeBoutiqueDescription'>{boutiqueData.description}</p>
                    <p className='homeBoutiqueFeatures'>{boutiqueData.features}</p>
                    <a className='homeBoutiqueBtn' href={boutiqueData.button.href} target="_blank" rel="noreferrer">{boutiqueData.button.text}</a>
                </div>
            </div>
        </>
    );
}

export default HomeBoutique;
